export default {
    'newsletter.title': 'Bądź pierwszy, który się dowie',
    'newsletter.btn': 'Zapisz się',
    'newsletter.placeholder': 'Twój e-mail',
    'newsletter.subtitle': 'Bądź na bieżąco i dowiedz się jako pierwszy o nowościach!',
    'instagram.title': 'Obserwuj nas',
    'contact.title': 'Potrzebujesz pomocy?',
    'contact.hours': 'Pon - Pt: 9:00 - 19:00',
    'login.title': 'Logowanie do konta',
    'cart.orderRecap': 'Podsumowanie zamówienia',
    "cart.empty": "Twój koszyk jest pusty",
    "cart.back": "Wróć do sklepu",
    "prefix": 'Przesyłając wiadomość, zgadzasz się z ',
    "privacy": 'polityką prywatności'
}
